import { getScoredetail,getScoreData } from "@/js/service/scoredetail/index.js";

/**
 * 项目评分详情
 * @type {Module}
 */
export const serviceScoreDetail = {
    namespaced: true,
    state: {
        //用户相关数据
        userinfo: [],
        service: [], //全国冷暖风水服务能力评分
        customer: [], //月度评分
        contract_id:'',//项目id
        topData:{},//不合格数量等等
        AcceptData:[],//验收数量
    },
    mutations: {
        changeUserInfo(state, payload) {
            state.userinfo = payload;
        },
        changeService(state, payload) {
            state.service = payload;
        },
        changeCustomer(state, payload) {
            state.customer = payload;
        },
        saveContract_id (state, payload) {
            // console.log(payload.contract_id,'id');
            state.contract_id = payload.contract_id
        },
        savetopData (state, payload) {
            state.topData = payload
        },
        saveAcceptData (state, payload) {
            state.AcceptData = payload
        },
        changeStatus (state, payload) {
            let AcceptData = state.AcceptData
            AcceptData[payload].status = !AcceptData[payload].status
            // state.AcceptData = AcceptData
        }
    },
    actions: {
        async getData({ commit, state }, payload) {
            await getScoredetail(payload).then((res) => {
                commit('saveContract_id',payload)
                let data = res.data.data.result;
                commit("changeUserInfo", data.user_info);

                let topData = data.statistics
                console.log(topData, "topData");
                commit('savetopData',topData);
                let list = data.rectify.list ||  data.rectify
                list = list.map(item => {
                    item.status = true
                    return item
                })
                commit('saveAcceptData',list)

                let service = data.service;
                let reallyService = [];
                let serviceObj = {
                    title: "全国冷暖风水服务能力评分",
                    score: service.score,
                    EvaScoreList: [
                    ], //存放进度条数据的数组
                };
                if (service.air_condition_system!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "空调系统施工与安装",
                            value: service.air_condition_system,
                        },
                    )
                }
                if (service.wall_furnace_system!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "壁挂炉系统施工与安装",
                            value: service.wall_furnace_system,
                        },
                    )
                }
                if (service.primary_air_system!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "新风系统施工与安装",
                            value: service.primary_air_system,
                        },
                    )
                }
                if (service.transition_issues!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "交接问题",
                            value: service.transition_issues,
                        },
                    )
                }
                if (service.system_debug!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "系统调试能力",
                            value: service.system_debug,
                        },
                    )
                }
                if (service.delivery_quality!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "竣工交付质量",
                            value: service.delivery_quality,
                        },
                    )
                }
                if (service.material_use!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "系统材料使用规范",
                            value: service.material_use,
                        },
                    )
                }
                if (service.draw_application!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "图纸应用",
                            value: service.draw_application,
                        },
                    )
                }
                if (service.live_safe!== '') {
                    console.log(service.live_safe,'live_safe')
                    serviceObj.EvaScoreList.push(
                        {
                            name: "现场安全",
                            value: service.live_safe,
                        },
                    )
                }
                if (service.proficiency_use!== '') {
                    serviceObj.EvaScoreList.push(
                        {
                            name: "艾暖通使用熟练度",
                            value: service.proficiency_use,
                        },
                    )
                }
                reallyService.push(serviceObj)

                // console.log(reallyService);
                commit("changeService", reallyService);

                let customer = data.customer
                let reallyCustomer = [];
                let customerObj = {
                    title: "全国冷暖风水服务综合能力月度评分",
                    score:customer.score,
                    content:customer.content,
                    voice:customer.voice,
                    EvaScoreList: [
                    ],

                }

                if (customer.sale_score!= undefined) {
                    customerObj.EvaScoreList.push(
                        {
                            name: "销售体验满意度",
                            value: service.sale_score,
                        },
                    )
                }
                if (customer.sign_score!= undefined) {
                    customerObj.EvaScoreList.push(
                        {
                            name: "销售体验满意度",
                            value: service.sign_score,
                        },
                    )
                }
                if (customer.work_score!= undefined) {
                    customerObj.EvaScoreList.push(
                        {
                            name: "系统施工满意度",
                            value: service.work_score,
                        },
                    )
                }
                if (customer.delivery_score!= undefined) {
                    customerObj.EvaScoreList.push(
                        {
                            name: "监理验收满意度",
                            value: service.delivery_score,
                        },
                    )
                }
                if (customer.service_score!=undefined) {
                    customerObj.EvaScoreList.push(
                        {
                            name: "服务效率满意度",
                            value: service.service_score,
                        },
                    )
                }
                reallyCustomer.push(customerObj)

                commit("changeCustomer", reallyCustomer);

            });
        },

        // 获取支持人员的数据
        async getScoreData ({state,commit},payload) {
            await getScoreData(payload).then (res => {
                console.log(res,'res')
                commit('saveAcceptData',res.data.data.result[state.contract_id])
            })
        },
        async getScoreDataV2 ({state,commit},payload) {
            return new Promise(resolve => {
                getScoreData(payload).then (res => {
                    resolve(res)
                })
            })
        },
    },
    getters: {},
};
